/**
 * This is the table that is built after the button click is pressed
 */
import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import formatNumbers from 'util/formatNumbers';
import {Link} from 'react-router';
import _ from 'lodash'
import moment from 'moment';
import CustomModalDialog from 'shared/CustomModalDialog';
import FaCommenting from 'react-icons/lib/fa/commenting';
import {ADD_SELECTED_TRANSACTIONS, REMOVE_SELECTED_TRANSACTIONS} from 'actions/actionTypes';
import config from '../../../config';
import {displayPayoutPercentage, calculateTransactionPayoutAmount} from 'dashboard/transactions/transactionsPageMethods';

import {
  actionsFormatter,
  customFormatter,
  customTableSelect,
  getFieldByPathFormatter,
  historyDataFormatter,
  priceFormatter
} from 'util/Utils';
import HistoryDataModal from 'shared/HistoryDataModal';

class AdminTransactionListTable extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            perPage: config.table.numberPerPage,
            searchPlaceholder: '',
            historyDataModalVisible: false,
            currentRecord: {},
        };
    }

    componentDidMount() {
        setTimeout(function () {
            this.setState({'searchPlaceholder': 'trigger_table_render'});
        }.bind(this), 1000)
    }

    onRowSelect(row, isSelected, e) {
        var actionName = isSelected ? ADD_SELECTED_TRANSACTIONS : REMOVE_SELECTED_TRANSACTIONS;
        this.props.dispatchAction([row], actionName)
    }

    onAllRowSelect(isSelected, rows) {
        console.log('in all rows select', rows.length);
        var actionName = isSelected ? ADD_SELECTED_TRANSACTIONS : REMOVE_SELECTED_TRANSACTIONS;
        this.props.dispatchAction(rows, actionName)
    }

    customMultiSelect(props) {
         return customTableSelect(props, {
            table: this.refs.table,
            selectedRows: this.props.adminTransactions.selectedTransactions,
          });
    }

    customLinkFormatter(cell, row) {

        if (row.SaleData && (row.SaleData['OrderID'] || row.SaleData['OrderNumber'])) {
            if (row.SaleData['OrderID'] && row.SaleData['OrderNumber']) {
                return (
                    <a target="_blank"
                       href={ config.getEnvironment().shopify.orderUrlTemplate.replace("[link_value]", row.SaleData['OrderID']) }>{row.SaleData['OrderNumber']}</a>
                );
            } else if (row.SaleData['OrderID']) {
                return (
                    <a target="_blank"
                       href={ config.getEnvironment().shopify.orderUrlTemplate.replace("[link_value]", row.SaleData['OrderID']) }>Order
                        ID</a>
                );
            } else {
                return (
                    <a target="_blank"
                       href={ config.getEnvironment().shopify.shopUrl + '/admin/orders.json?name=%23' + row.SaleData['OrderNumber'] + '&status=any'  }>#{row.SaleData['OrderNumber']}</a>
                );
            }
        } else {
            return ''
        }
    }

    showRemoveDialog(row) {
        this.props.showRemoveDialog(row)
    }

    hideModal() {
        this.setState({currentRecord: {}, historyDataModalVisible: false});
    }

    editTransaction(row) {
        this.props.editTransaction(row);
    }

    customActionsFormatter(cell, row, extra) {
        var menuItemsMap = [ ];
        if (config.checkAccessRights.call(this,{ resources:['payout_registry_edit']})){
            menuItemsMap.push({onClick: 'editTransaction', label: 'Edit'})
        }

        if (_.size(_.intersection(this.props.userReducer.user.Roles, ['Administrator'])) > 0 && row.Status !== 'Paid') {
            menuItemsMap.push({onClick: 'showRemoveDialog', label: 'Remove Transaction'})
        }
        return actionsFormatter.call(this, cell, row, {menuItemsMap})
    }

    typeFormatter(cell, row) {

             if (row.Type == 'WorkingTime') {
                 if (row.CustomData.PayoutRequestID) {
                     return <Link className=" underlineText" target="_blank"
                                  to={'/admin/time-tracking?searchText=' + encodeURIComponent(row.CustomData.PayoutRequestID)}>{ _.startCase(row.Type)}</Link>
                 } else {
                     return _.startCase(row.Type)
                 }
             }
    }

      calculatePayoutFormatter(cell, row) {
        if (row.Type == 'Sale') {
          if (_.isUndefined(row.SaleData.PayoutPercentage)) {
            return this.props.displayMessage({
              'messageType': 'warning',
              'messageCode': 'Product payout is not available in transaction record'
            });
          }

          const payoutAmount = calculateTransactionPayoutAmount(row, this.props.appData.FeatureFlags);
          return '+' + formatNumbers.formatMoney(payoutAmount,{precision: payoutAmount % 1 == 0 ? 0 : 2});
        } else if (row.Type == 'Credit') {
          return '+' + formatNumbers.formatMoney(row.Amount,{precision: row.Amount % 1 == 0 ? 0 : 2});
        } else if (row.Type == 'Fee' || row.Type == 'PickupFee' || row.Type == 'WorkingTime') {
          return '-' + formatNumbers.formatMoney(row.Amount, {precision: row.Amount % 1 == 0 ? 0 : 2});
        }
      }

    customSellerButtonFormatter(cell, row) {
        if(_.get(row,'ContractorID._id')){
            return <div>
                <div>Contractor</div>
                <span className="blue cursor-pointer" onClick={(e) => {
                window.open(config.getEnvironment().clientSideURL+`/admin/time-tracking-registry?ContractorID=${encodeURIComponent(row.ContractorID._id)}&searchText=`+ _.get(row,'PayoutID')+'&Statuses=Paid', "_blank")

            }}>  {_.get(row,'UserID.firstName') + ' ' +_.get(row,'UserID.lastName') } </span>
            </div>
        }else{
            return <span className="blue cursor-pointer" onClick={(e) => {
                this.props.search({SellerID: row.SellerID._id});
                this.props.setSearchParams({SellerID: row.SellerID._id});
            }}>{_.get(row.SellerID,'DisplayName', '')}</span>
        }
    }

    render() {
        const selectRowProp = {
            mode: 'checkbox',
            columnWidth: '29px',
            onSelect: this.onRowSelect.bind(this),
            onSelectAll: this.onAllRowSelect.bind(this),
            customComponent: this.customMultiSelect.bind(this)
        }
        const hideColumnsForLPN = !!(String(_.get(this.props, 'location.query.ScannedLPN', '')).trim())

        return (
            <div className="panel panel-default">

                <div className=" databases-table">

                    <BootstrapTable ref='table'
                                    data={this.props.data}
                                    selectRow={ selectRowProp }
                                    remote={true}
                                    searchPlaceholder={this.state.searchPlaceholder}
                                    hover={true}
                                    condensed={true}
                                    striped={true}
                                    options={ {
                                        ...config.bootstrapTableOptions,
                                        onSortChange: this.props.onSortChange
                                    } }>

                        <TableHeaderColumn width="80px" dataField="SellerID.DisplayName" dataAlign="center"
                                           dataFormat={ this.customSellerButtonFormatter.bind(this) } dataSort={true}>Seller</TableHeaderColumn>

                        <TableHeaderColumn width="70px" columnClassName={'break-word'} dataField="UserID.email"
                                           dataAlign="center"
                                           formatExtraData={ {path: ['UserID', 'email']}}
                                           dataFormat={ getFieldByPathFormatter }
                                           hidden={hideColumnsForLPN}
                                           dataSort={true}>Email</TableHeaderColumn>

                        <TableHeaderColumn width="70" dataField="ProductID.ProductName" dataAlign="center"
                                           formatExtraData={ {path: ['ProductID', 'ProductName']}}
                                           dataFormat={ getFieldByPathFormatter } dataSort={true}>Product
                            Title</TableHeaderColumn>

                        <TableHeaderColumn width="30px" dataAlign="center" dataField="ChangeLog"
                                           dataSort={true}
                                           hidden={hideColumnsForLPN}
                                           dataFormat={(cell, row)=> historyDataFormatter.call(this,row,  {field:'ChangeLog'} )}>Log</TableHeaderColumn>

                        <TableHeaderColumn  width="30px"   dataSort={true} dataField='SaleData.ShopifyOrderComments'
                                           dataFormat={ customFormatter }
                                           formatExtraData={ {path:[  'getObject']  , format: (row)=> {
                                               return <div>

                                                   {_.get(row,'SaleData.ShopifyOrderComments.0.Message') && <span >
                                                     <Link className="cursor-pointer" onClick={() => {

                                                         this.setState({
                                                             currentRecord: _.extend({}, row, {currentField:  'Comments', Comments:_.map(_.get(row,'SaleData.ShopifyOrderComments'), item=>{

                                                                 return  {createdAt:item.createdAt, commentImages:_.get(item, 'Attachments',[]), CommentTextAsHTML:item.Message}})
                                                             , modalTitle:'Shopify order comments'}),
                                                             historyDataModalVisible: true
                                                         })

                                                     }}
                                                     > <FaCommenting  className={'  font-size-20 purple '}></FaCommenting></Link>
                                                   </span>}
                                               </div>

                                           }}}
                                           dataAlign="center"
                        >Comments</TableHeaderColumn>

                        <TableHeaderColumn width="70px" dataAlign="center"
                                           dataField="Description" dataSort={true}>Description</TableHeaderColumn>

                        <TableHeaderColumn dataField="_id" isKey={true} hidden={true}
                                           autoValue={ true } hiddenOnInsert>Id</TableHeaderColumn>

                        <TableHeaderColumn width="40px" dataField="SoldAt" dataAlign="center"
                                           dataFormat={ customFormatter }
                                           formatExtraData={ {
                                               path: ['SoldAt'],
                                               format: (value) => {
                                                   if (value) {
                                                       return <div>
                                                           <div>{  moment(value).format('MM/DD')}</div>
                                                           <div>{  moment(value).format('YYYY')}</div>
                                                       </div>
                                                   } else {
                                                       return ''
                                                   }
                                               }
                                           }}
                                           dataSort={true}>Sold in Shopify</TableHeaderColumn>

                        <TableHeaderColumn width="40px" dataField="FulfilledAt" dataAlign="center"
                                           dataFormat={ customFormatter }
                                           formatExtraData={ {
                                               path: ['FulfilledAt'],
                                               format: (value) => {
                                                   if (value) {
                                                       return <div>
                                                           <div>{  moment(value).format('MM/DD')}</div>
                                                           {/*<div>{  moment(value).format('HH:mm')}</div>*/}
                                                           <div>{  moment(value).format('YYYY')}</div>
                                                       </div>
                                                   } else {
                                                       return ''
                                                   }
                                               }
                                           }}
                                           dataSort={true}>Fulfilled in Shopify</TableHeaderColumn>

                        <TableHeaderColumn width="40px" dataField="LatestPayoutRequestDate" dataAlign="center"
                                           dataFormat={ customFormatter }
                                           formatExtraData={ {
                                               path: ['LatestPayoutRequestDate'], path2: ['Status'],
                                               format: (LatestPayoutRequestDate) => {
                                                   if (LatestPayoutRequestDate) {
                                                       return <div>
                                                           <div>{  moment(LatestPayoutRequestDate).format('MM/DD')}</div>
                                                           <div>{  moment(LatestPayoutRequestDate).format('YYYY')}</div>
                                                       </div>
                                                   } else {
                                                       return ''
                                                   }
                                               }
                                           }
                                           } hidden={hideColumnsForLPN}
                                           dataSort={true}>Payout Request Date</TableHeaderColumn>

                        <TableHeaderColumn width="40px" dataField='FundsAvailableForPaymentAt' dataAlign="center"
                                           dataFormat={ customFormatter }
                                           editable={false}
                                            formatExtraData={ {
                                               path: ['FundsAvailableForPaymentAt'],
                                               format: (value) => {
                                                   if (value) {
                                                       return <div>
                                                           <div>{  moment(value).format('MM/DD')}</div>
                                                           {/*<div>{  moment(value).format('HH:mm')}</div>*/}
                                                           <div>{  moment(value).format('YYYY')}</div>
                                                       </div>
                                                   } else {
                                                       return ''
                                                   }
                                               }}}
                                           hidden={hideColumnsForLPN}
                                           dataSort={true}>Fund Available</TableHeaderColumn>

                        <TableHeaderColumn width="40px" dataField="PaidAt" dataAlign="center"
                                           dataFormat={ customFormatter }
                                           formatExtraData={ {
                                               path: ['PaidAt'],
                                               format: (value) => {
                                                   if (value) {
                                                       return <div>
                                                           <div>{  moment(value).format('MM/DD')}</div>
                                                           <div>{  moment(value).format('YYYY')}</div>
                                                       </div>
                                                   } else {
                                                       return ''
                                                   }
                                               }
                                           }}
                                           dataSort={true}>Paid At</TableHeaderColumn>
                        <TableHeaderColumn width="40px" dataField="SaleData.OrderNumber"
                                           dataFormat={ this.customLinkFormatter }
                                           dataAlign="center" dataSort={true}>Order #</TableHeaderColumn>

                        <TableHeaderColumn width="55px"
                                           dataFormat={ customFormatter } formatExtraData={ {
                                            path: ['getObject'], format: (item) => {
                                              const {ProductBasePriceWithDiscount = -1} = item.SaleData || {};

                                                return <div>
                                                  <div>{formatNumbers.formatMoney(item.Amount,{precision:  item.Amount % 1 == 0 ? 0 : 2})}</div>
                                                  {ProductBasePriceWithDiscount > -1 &&
                                                    <div className="orange top5">{formatNumbers.formatMoney(ProductBasePriceWithDiscount,
                                                      {precision: ProductBasePriceWithDiscount % 1 == 0 ? 0 : 2})
                                                      }</div>
                                                  }

                                                </div>;
                                            }}}

                                           dataAlign="center"  columnClassName={'break-word'}
                                           dataField="Amount" dataSort={true}>Amount Sold</TableHeaderColumn>

                        <TableHeaderColumn width="60px" dataField='Status' dataAlign="center"
                                           dataFormat={ customFormatter } formatExtraData={ {
                            path: ['getObject'], format: (item) => {
                                if (_.includes(['PendingPayout', 'Paid'],item.Status )){
                                    var foundPendingPayoutChangeLog = _.findLast(_.get(item, 'ChangeLog', []), item => {
                                        return _.get(item, 'FieldChanged') =='Status' && _.get(item, 'To') == 'PendingPayout'
                                    })
                                    return <div>
                                        <div>{_.startCase(_.get(item,'Status'))}</div>
                                        {_.get(foundPendingPayoutChangeLog, 'CustomData.PayoutMethod') &&
                                        <div className="green top5">{_.get(foundPendingPayoutChangeLog, 'CustomData.PayoutMethod') }</div>
                                        }
                                        {_.get(foundPendingPayoutChangeLog, 'CustomData.PayoutMethodDetails') &&
                                        <div className="orange top5">{_.get(foundPendingPayoutChangeLog, 'CustomData.PayoutMethodDetails') }</div>
                                        }
                                    </div>
                                }else{
                                    return _.startCase(_.get(item,'Status'))
                                }

                            }
                        }}
                                           dataSort={true}>Status</TableHeaderColumn>
                                           
                        <TableHeaderColumn width="40px"  dataAlign="center" dataField='MarketName'
                                           dataSort={true}>Location</TableHeaderColumn>

                        <TableHeaderColumn width="60px" columnClassName={ 'blue' } dataAlign="center"
                                           dataFormat={ this.calculatePayoutFormatter.bind(this) }
                        >Payout</TableHeaderColumn>

                        <TableHeaderColumn width="30" dataField="ProductID.Payout" dataAlign="center"
                                           dataFormat={ displayPayoutPercentage.bind(this) }
                                         dataSort={true}>Payout
                            %</TableHeaderColumn>

                        <TableHeaderColumn width="50px" dataAlign="center" dataFormat={  this.typeFormatter }
                                           dataField="Type" dataSort={true}>Type</TableHeaderColumn>

                        <TableHeaderColumn columnClassName={'actions-column'}
                                           dataAlign="center"
                                           dataFormat={ this.customActionsFormatter.bind(this) }
                        ></TableHeaderColumn>

                    </BootstrapTable>
                </div>
              <CustomModalDialog
                show={this.state.showModal}
                modalTitle={this.state.modalTitle}
                modalContent={this.state.modalContent}
                closeModal={(e) =>
                  this.setState({
                    showModal: false,
                    modalContent: ()=>''
                  })
                }
              ></CustomModalDialog>
                <HistoryDataModal data={this.state.currentRecord} hideModal={this.hideModal.bind(this)}
                                show={this.state.historyDataModalVisible}></HistoryDataModal>
            </div>

        );
    }
}

export default AdminTransactionListTable;
